import { NameDto } from 'api/Common/Types'

export interface PaymentProviderMethodDto {
  methodType: NameDto
  paymentProvider: NameDto<string>
}

export interface PaymentProviderGroupDto {
  dateCreated: string
  dateUpdated: string
  id: string
  methods: PaymentProviderMethodDto[]
  name: string
  pspGroupType: NameDto
}

export interface GroupMethod {
  pspGroupId?: string
  paymentProviderId: string
  methodTypeId: number
}

export interface CreateGroupMethodDto {
  paymentProviderId: string
  methodTypeId: number
}

export interface UpdatePaymentProviderGroupDto {
  pspGroupId?: string
  name: string
  pspGroupTypeId?: number
  groupMethods: GroupMethod[]
}

export interface CreatePaymentProviderGroupDto {
  groupMethods: CreateGroupMethodDto[]
  pspGroupTypeId?: number
  name: string
}

export interface PaymentProviderOptionDto {
  id: string
  name: string
  processor: NameDto
  depositAutomationType: NameDto
  withdrawAutomationType: NameDto
  service: NameDto
}

export enum PSPMethodTypes {
  Uncovered = 0,
  Deposit = 100,
  Withdraw = 200,
}

export enum PSPGroupTypes {
  DepositWithdraw = 3400,
  Uncovered = 3500,
}

export enum PaymentProviderKey {
  name = 'name',
}

export enum PaymentProviderFilterKey {
  name = 'Name',
  paymentProvider = 'PaymentProviderId',
  paymentMethodType = 'PspGroupMethodTypeId',
}
